import React, { createContext } from "react";
import { useExpanded, useFilters, useTable } from "react-table";
import { PatientComplementTableBody } from "./PatientComplementTableBody";
import { PatientComplementTableHead } from "./PatientComplementTableHead";

export const TableContext = createContext({});

export const PatientComplementTable = ({
  columns,
  data,
  filters = {},
  checkFilter,
  id,
  ...props
}) => {
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { hiddenColumns: ["status"] },
    },
    useFilters,
    useExpanded
  );
  const { getTableProps } = tableInstance;

  return (
    <TableContext.Provider value={{ ...tableInstance }}>
      <table className="myTable" {...getTableProps()}>
        <PatientComplementTableHead />
        <PatientComplementTableBody id={id} {...props} />
      </table>
    </TableContext.Provider>
  );
};
